import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component
export default class UsersFilter extends Vue {
  @Prop({ required: true }) filter!: string;

  value: string[] = [];

  @Emit()
  filterChange(filter: string): void {
    this.$emit('filterChange', filter);
  }
}
